<template>
  <!-- 搜索联系人结果 -->
  <div class="bg-white z-index-1 left-0 bottom-0 right-0">
    <div style="background:#F5F5F5" class="" v-if="navSelctType == 0"></div>
    <div class="h-38 l-h-38 p-l-16 f-s-12" style="color: #999999;border-bottom: 1px solid #f2f2f2" v-if="navSelctType == 0">{{currentnavSelctType=='1'?'网点':currentnavSelctType=='2'?'我的组织':'群聊'}}</div>
    <div class="t-a-center p-x-20 l-h-24 p-y-10" v-if="noData && keyWord">未搜索到 “{{keyWord}}” 的相关内容</div>
    <template v-else-if="!keyWord">
      <div class="t-a-center" style="margin: 68px auto auto;">
        <img src="@/assets/images/im/kong-order@2x.png" width="155px" height="104px"/>
      </div>
      <div class="f-s-12 t-a-center" style="color:#999999">输入关键字开始搜索</div>
    </template>
    <ul>
      <li class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="(item, index) in searchedData" :key="index" v-if="(navSelctType == 0 && 3 > index && currentnavSelctType==2) || (navSelctType == 2&&currentnavSelctType==2)" @click="itemClickEvent(item)">
        <div class="d-table-cell v-a-middle h-100-p w-64" style="text-align: center;">
          <span class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #653EB3;">{{getShortNickname(item.nickName||item.mobile)}}</span>
        </div>
        <div class="p-relative d-table-cell v-a-middle h-100-p">
          <div :style="{width:listWidth+'px'}">
            <div>
              <p class="t-ellipsis l-h-1-6-em m-r-10" v-if="item.isChinese" v-html="item.nickNameHtml"></p>
              <p class="t-ellipsis l-h-1-6-em m-r-10" v-else>{{item.nickName}}</p>
              <p class="t-ellipsis l-h-1-6-em m-r-10" v-if="item.isNumber" v-html="item.mobileHtml"></p>
              <p class="t-ellipsis l-h-1-6-em m-r-10" v-else>{{item.mobile}}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center cursor-pointer" style="color: #653EB3;border-bottom: 1px solid #f2f2f2;" v-if="navSelctType == 0 && !noData && searchedData.length > 3" @click="selectedContacts"><span class="d-block">查看更多相关我的组织成员</span><img src="@/assets/images/im/arrow-right@2x.png" class="d-block" style="width: 8px;height:14px"/></div>
  </div>
</template>
<script>
export default {
  props: {
    im: {
      type: Object,
      default: function () {
        return {}
      }
    },
    width: {
      type: Number,
      default: 250
    },
    searchedNumber: {
      type: Array,
      default: function(){
        return []
      }
    },
    keyWord:{
      type:String,
      default: ""
    },
    navSelctType:{
      type: String,
      default: "0"
    },
    currentnavSelctType:{
      type: String,
      default: "1"
    },
  },
  data: function () {
    return {
      listWidth: 185,
      searchedData:[],
      noData: false
    };
  },
  components: {
    
  },
  created: function () {
    
  },
  mounted:function () {
    
  },
  computed: {
   
  },
  methods: {
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    setColorForKeyWord(arr){
      if(this.currentnavSelctType == '2'){
        let $this = this,data = arr.concat();
        if($this.isChinese($this.keyWord)){
          data.map(function(item){
            if(item.nickName){
              item.nickNameHtml = item.nickName.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#653EB3">$1</span>');
              item.isChinese = true;
            }
           
          })
        }else if($this.isNumber($this.keyWord)){
          data.map(function(item){
            if(item.mobile){
              item.mobileHtml = item.mobile.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#653EB3">$1</span>');
              item.isNumber = true;
            }

          })
        };
        $this.searchedData = data;
      }

    },
    selectedContacts:function(){
      // 需要判断网点还是组织 群聊类型 数据来源也是
      this.$emit("switchTab",this.currentnavSelctType);
    },
    // 点击联系人
    itemClickEvent: function (item) {
      this.$emit('createSession', item);
    },
    // 判断是否包含中文
    isChinese(str) {
      let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
      if (reg.test(str)) return true;
      return false;
    },
    // 判断是否为数字
    isNumber(str) {
      let reg = /^\d+$/g;
      if (reg.test(str)) return true;
      return false;
    },
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    },
    searchedNumber:{
      handler:function(arr){
        let $this = this;
        $this.searchedData = [];
        if(arr.length == 0) {
            $this.noData = true;
            return;
        };
        $this.noData = false;
        $this.setColorForKeyWord(arr)
      },
      immediate: true
    }
  }
}
</script>
